// type of actions supported by authentication

export const AUTH_LOGIN_LOADING = "auth/login/loading";
export const AUTH_LOGIN_ERROR = "auth/login/error";
export const AUTH_LOGIN_SUCCESS = "auth/login/success";

//action for logout
export const AUTH_LOGOUT = "auth/logout";